//---------	Global imports
import React from 'react';

//---------	Styles
import './styles.sass';

//---------	Translations
import { T } from '../../../translations';


class ProductDescription extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();
    
    this.description = props.description;
  }

  
  
  //---------	Render
  render() {
    return (
      <div className="CalipsyProductDescription">
        <div className="CalipsyProductDescription-container">
          <div className="CalipsyContent">
            <h3>A few words about this product</h3>
            <div dangerouslySetInnerHTML={{__html: this.description}}></div>
            <h3 className="CalipsyContent-title">Product care</h3>
            <p className="CalipsyProductDescription-care" dangerouslySetInnerHTML={{__html: T.product.care}}></p>
            <h3 className="CalipsyContent-title">Remember</h3>
            <p className="CalipsyProductDescription-warning" dangerouslySetInnerHTML={{__html: T.product.warning}}></p>
          </div>
        </div>
      </div>
    );
  }
}

export default ProductDescription;


// WEBPACK FOOTER //
// ./src/components/ProductDescription/index.js